import { render } from "./AddOrEditDictItem.vue?vue&type=template&id=c1251be6"
import script from "./AddOrEditDictItem.vue?vue&type=script&lang=js"
export * from "./AddOrEditDictItem.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__